import axios from 'axios';
import moment from 'moment';

class MitReservationAnalyticsService {
    constructor() {
    }

    getReservationsSpaceUsage(startDate, endDate){
        return new Promise ((resolve, reject) => {

            let startUTC = moment(startDate).utc().format('YYYY-MM-DD hh:mm A');
            let endUTC = moment(endDate).utc().format('YYYY-MM-DD hh:mm A');

            axios.get('/api/v1/manager/reservations/analytics/space_usage_hours?startUTC='+startUTC+'&endUTC='+endUTC)
            .then((response) => {

                let data = {
                    datasets: [],
                    title:'',
                    labelX:'Space',
                    labelY:'Hours/Counts'
                };
                let datasetHoursReserved = {
                    label:'Hours Reserved',
                    data:[]
                };
                let datasetNumTimesReserved = {
                    label:'Times Reserved',
                    data:[]
                };

                for(let x = 0; x < response.data.stats.length; x++){
                    datasetHoursReserved.data.push({
                        x:response.data.stats[x].mitId,
                        y:response.data.stats[x].totalHoursUsedNumber
                    });
                    datasetNumTimesReserved.data.push({
                        x:response.data.stats[x].mitId,
                        y:response.data.stats[x].totalReservationCount
                    });
                }

                data.datasets.push(datasetHoursReserved);
                data.datasets.push(datasetNumTimesReserved);

                return resolve(data);
            })
            .catch((error) => {
                console.log('ERROR:', error);
                return reject(error);
            });
        });
    }

    getReservationsSpaceUsageByDay(startDate, endDate){
        return new Promise ((resolve, reject) => {

            // startUTC = startDate || moment().startOf('day').utc().format('YYYY-MM-DD hh:mm A');
            // endUTC = endDate || moment().endOf('day').utc().format('YYYY-MM-DD hh:mm A');

            let startUTC = moment(startDate).utc().format('YYYY-MM-DD hh:mm A');
            let endUTC = moment(endDate).utc().format('YYYY-MM-DD hh:mm A');

            axios.get('/api/v1/manager/reservations/analytics/space_usage_hours_by_day?startUTC='+startUTC+'&endUTC='+endUTC)
            .then((response) => {

                let data = {
                    //labels: ['Sunday', 'Monday', 'Tuesday', 'Wednesday','Thursday','Friday','Saturday'],
                    datasets: []
                };
                let datasetHoursReserved = {
                    label:'Hours Reserved',
                    data:[
                        { x:'Sunday',y:0},
                        { x:'Monday',y:0},
                        { x:'Tuesday',y:0},
                        { x:'Wednesday',y:0},
                        { x:'Thursday',y:0},
                        { x:'Friday',y:0},
                        { x:'Sunday',y:0}
                    ]
                };
                let datasetNumTimesReserved = {
                    label:'Times Reserved',
                    data:[
                        { x:'Sunday',y:0},
                        { x:'Monday',y:0},
                        { x:'Tuesday',y:0},
                        { x:'Wednesday',y:0},
                        { x:'Thursday',y:0},
                        { x:'Friday',y:0},
                        { x:'Sunday',y:0}
                    ]
                };
                
                for(let x = 0; x < response.data.stats.length; x++){

                    switch(response.data.stats[x].dayOfWeek){
                        case 'sunday':
                            datasetHoursReserved.data[0].y += parseInt(response.data.stats[x].totalHoursUsedNumber);
                            datasetNumTimesReserved.data[0].y += parseInt(response.data.stats[x].totalReservationCount);
                            break;
                        case 'monday':
                            datasetHoursReserved.data[1].y += parseInt(response.data.stats[x].totalHoursUsedNumber);
                            datasetNumTimesReserved.data[1].y += parseInt(response.data.stats[x].totalReservationCount);
                            break;
                        case 'tuesday':
                            datasetHoursReserved.data[2].y += parseInt(response.data.stats[x].totalHoursUsedNumber);
                            datasetNumTimesReserved.data[2].y += parseInt(response.data.stats[x].totalReservationCount);
                            break;
                        case 'wednesday':
                            datasetHoursReserved.data[3].y += parseInt(response.data.stats[x].totalHoursUsedNumber);
                            datasetNumTimesReserved.data[3].y += parseInt(response.data.stats[x].totalReservationCount);
                            break;
                        case 'thursday':
                            datasetHoursReserved.data[4].y += parseInt(response.data.stats[x].totalHoursUsedNumber);
                            datasetNumTimesReserved.data[4].y += parseInt(response.data.stats[x].totalReservationCount);
                            break;
                        case 'friday':
                            datasetHoursReserved.data[5].y += parseInt(response.data.stats[x].totalHoursUsedNumber);
                            datasetNumTimesReserved.data[5].y += parseInt(response.data.stats[x].totalReservationCount);
                            break;
                        case 'saturday':
                            datasetHoursReserved.data[6].y += parseInt(response.data.stats[x].totalHoursUsedNumber);
                            datasetNumTimesReserved.data[6].y += parseInt(response.data.stats[x].totalReservationCount);
                            break;
                    }
                    // datasetHoursReserved.data.push({
                    //     x:response.data.stats[x].day,
                    //     y:response.data.stats[x].totalHoursUsedNumber
                    // });
                    // datasetNumTimesReserved.data.push({
                    //     x:response.data.stats[x].day,
                    //     y:response.data.stats[x].totalReservationCount
                    // });
                }

                data.datasets.push(datasetHoursReserved);
                data.datasets.push(datasetNumTimesReserved);

                return resolve(data);
            })
            .catch((error) => {
                console.log('ERROR:', error);
                return reject(error);
            });
        });
    }

}

export default new MitReservationAnalyticsService();
